import { BOOLEAN_SELECT_LIST_ITEMS } from "@compass/core";
import { CustomDataModelField, LkCustomDataModelFieldTypeId } from "generated/openApi";
import produce from "immer";
import { DatePicker } from "./DatePicker";
import { Input } from "./Input";
import { Select } from "./Select";

export const CustomDataModelFieldEditor = (props: {
  field: CustomDataModelField;
  dataModel: any;
  setDataModel: (value: any) => void;
  errors: any | undefined;
}) => {
  return (
    <>
      {props.field.fieldTypeId === Number(LkCustomDataModelFieldTypeId.TextNumber) && (
        <Input
          label={props.field.name}
          required={props.field.isMandatory}
          errors={props.errors}
          maxLength={200} // hardcode for now
          value={props.dataModel?.[props.field.fieldNameCamelCase!]}
          onChange={(e) =>
            props.setDataModel(
              produce(props.dataModel, (draft) => {
                draft![props.field.fieldNameCamelCase!] = e.target.value;
              })
            )
          }
        />
      )}

      {props.field.fieldTypeId === Number(LkCustomDataModelFieldTypeId.Date) && (
        <DatePicker
          label={props.field.name}
          required={props.field.isMandatory}
          errors={props.errors}
          value={props.dataModel?.[props.field.fieldNameCamelCase!]}
          onChange={(value) =>
            props.setDataModel(
              produce(props.dataModel, (draft) => {
                draft![props.field.fieldNameCamelCase!] = value;
              })
            )
          }
        />
      )}

      {props.field.fieldTypeId === Number(LkCustomDataModelFieldTypeId.NullableBool) && (
        <Select
          label={props.field.name}
          required={props.field.isMandatory}
          errors={props.errors}
          value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.dataModel?.[props.field.fieldNameCamelCase!])}
          options={BOOLEAN_SELECT_LIST_ITEMS}
          getOptionLabel={(option) => option.name}
          onChange={(e, value) =>
            props.setDataModel(
              produce(props.dataModel, (draft) => {
                draft![props.field.fieldNameCamelCase!] = value?.id;
              })
            )
          }
        />
      )}

      {props.field.fieldTypeId === Number(LkCustomDataModelFieldTypeId.SelectList) && (
        <Select
          label={props.field.name}
          required={props.field.isMandatory}
          errors={props.errors}
          value={props.field?.selectList?.find((x) => x.id === props.dataModel?.[props.field.fieldNameCamelCase!])}
          options={props.field?.selectList}
          getOptionLabel={(option) => option.name}
          onChange={(e, value) =>
            props.setDataModel(
              produce(props.dataModel, (draft) => {
                draft![props.field.fieldNameCamelCase!] = value?.id;
              })
            )
          }
        />
      )}
    </>
  );
};
